import React from "react";
import {
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Trans, useTranslation } from "react-i18next";
// import { trackEvent } from "../analytics/gtagHelper";

interface FullScreenDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const { t } = useTranslation();

  const handleClose = (
    _event?: object,
    reason?: "backdropClick" | "escapeKeyDown" | "iconClick"
  ) => {
    try {
      //   trackEvent("termsDialogClose", {
      //     category: "Dialog",
      //     reason,
      //   });
    } catch {}
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullScreen={!isDesktop}>
      <IconButton
        aria-label={t("guidelines.closeAria")}
        onClick={() => setIsOpen(false)}
        sx={{
          position: "absolute",
          right: 20,
          top: 20,
          backgroundColor: "black",
          color: "white",
          "&:hover": {
            color: "black",
            transition: "0.2s",
          },
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          padding: 0,
          ...(isDesktop && { maxWidth: "450px" }),
        }}
      >
        <div className="bg-[#FFC3DE] h-[230px] flex justify-center">
          <img
            alt={t("guidelines.imageAlt")}
            src="/images/abu-dhabi-calling-pink.jpg"
            className="w-auto object-contain my-5"
          />
        </div>
        <Typography variant="h5" fontWeight="bold" sx={{ p: 3, pb: 0 }}>
          {t("guidelines.title")}
        </Typography>
        <Divider sx={{ mt: 3 }} />
        <Typography variant="body1" sx={{ p: 3 }}>
          <Trans
            i18nKey="guidelines.section1"
            components={{ strong: <strong /> }}
          />
        </Typography>
        <Typography variant="body1" sx={{ px: 3 }}>
          <Trans i18nKey="guidelines.section2" />
        </Typography>
        <Typography variant="body1" sx={{ p: 3 }}>
          <Trans i18nKey="guidelines.section3" />
        </Typography>
        <Typography variant="body1" sx={{ px: 3, pb: 3 }}>
          <Trans
            i18nKey="guidelines.note"
            components={{ strong: <strong /> }}
          />
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenDialog;
